import type { EntityId } from '@reduxjs/toolkit';
import type { ReactNode } from 'react';
import { useMultiAccordion } from '@/DesignSystem/Hook';
import type { IMultiAccordionProps } from '@/DesignSystem/Model/DataModel';
import Accordion from './Accordion';
const MultipleAccordion = <T = EntityId,>({
  className,
  multiple,
  defaultSelected,
  items,
  ClassBox
}: IMultiAccordionProps<T>): ReactNode => {
  const {
    onToggle,
    items: accordionItem,
    selected
  } = useMultiAccordion<T>({
    multiple,
    items,
    defaultSelected
  });
  return <div className={className} data-sentry-component="MultipleAccordion" data-sentry-source-file="MultipleAccordion.tsx">
      {accordionItem.map(item => <Accordion key={item.id as string} isOpen={selected.some(s => s === item.id)} onToggle={() => onToggle(item.id)} className={ClassBox} header={item.header}>
          {item.children}
        </Accordion>)}
    </div>;
};
export default MultipleAccordion;